import * as ACTION from 'constant/action/loader'
import { handleActions } from 'redux-actions'

const initialState = {
  articleSubmitting: false,
  attachmentSubmitting: false,
  categorySubmitting: false,
  datasetSubmitting: false,
  discoverySubmitting: false,
  helpSubmitting: false,
  insightSubmitting: false,
  loading: false,
  loadingArticleDescription: false,
  loadingLatestArticles: false,
  loadingPreviewArticles: false,
  loadingSearchResults: false,
  loginSubmitting: false,
  siteSubmitting: false,
  tagSubmitting: false,
  userSubmitting: false,
  webpageSubmitting: false
}

export default handleActions(
  {
    [ACTION.UPDATE_LOADING]: (state, action) => ({
      ...state,
      loading: action.payload
    }),
    [ACTION.UPDATE_LOADING_PREVIEW_ARTICLES]: (state, action) => ({
      ...state,
      loadingPreviewArticles: action.payload
    }),
    [ACTION.UPDATE_LOADING_DESCRIPTION]: (state, action) => ({
      ...state,
      loadingArticleDescription: action.payload
    }),
    [ACTION.UPDATE_ARTICLE_SUBMITTING]: (state, action) => ({
      ...state,
      articleSubmitting: action.payload
    }),
    [ACTION.UPDATE_ATTACHMENT_SUBMITTING]: (state, action) => ({
      ...state,
      attachmentSubmitting: action.payload
    }),
    [ACTION.UPDATE_LOADING_LATEST_ARTICLES]: (state, action) => ({
      ...state,
      loadingLatestArticles: action.payload
    }),
    [ACTION.UPDATE_CATEGORY_SUBMITTING]: (state, action) => ({
      ...state,
      categorySubmitting: action.payload
    }),
    [ACTION.UPDATE_DISCOVERY_SUBMITTING]: (state, action) => ({
      ...state,
      discoverySubmitting: action.payload
    }),
    [ACTION.UPDATE_HELP_SUBMITTING]: (state, action) => ({
      ...state,
      helpSubmitting: action.payload
    }),
    [ACTION.UPDATE_USER_SUBMITTING]: (state, action) => ({
      ...state,
      userSubmitting: action.payload
    }),
    [ACTION.UPDATE_LOADING_SEARCH_RESULTS]: (state, action) => ({
      ...state,
      loadingSearchResults: action.payload
    }),
    [ACTION.UPDATE_LOGIN_SUBMITTING]: (state, action) => ({
      ...state,
      loginSubmitting: action.payload
    }),
    [ACTION.UPDATE_SITE_SUBMITTING]: (state, action) => ({
      ...state,
      siteSubmitting: action.payload
    }),
    [ACTION.UPDATE_TAG_SUBMITTING]: (state, action) => ({
      ...state,
      tagSubmitting: action.payload
    }),
    [ACTION.UPDATE_INSIGHT_SUBMITTING]: (state, action) => ({
      ...state,
      insightSubmitting: action.payload
    }),
    [ACTION.UPDATE_DATASET_SUBMITTING]: (state, action) => ({
      ...state,
      datasetSubmitting: action.payload
    }),
    [ACTION.UPDATE_WEBPAGE_SUBMITTING]: (state, action) => ({
      ...state,
      webpageSubmitting: action.payload

    })
  },
  initialState
)
